export default {
  common__validation__is_required: 'Поле является обязательным',
  common__validation__invalid_format: 'Недопустимый формат',
  common__validation__invalid_file_size: 'Размер файла превышает максимальный лимит ({size})',
};
